import { Box, LinearProgress, Typography } from "@mui/material";
import {
  progressAge,
  progressCount,
  progressLabel,
  progressPercent,
} from "components/admin/DemoRunProgress.support";

// Live step + batch counts of a demo-data worker run; on a failed run, the last step it reported
export default function DemoRunProgress({ progress, failed = false }) {
  const label = progressLabel(progress);
  if (!label) return null;
  const percent = progressPercent(progress);
  const text = [
    failed ? `Last step: ${label}` : label,
    progressCount(progress),
    !failed && progressAge(progress),
  ]
    .filter(Boolean)
    .join(" · ");
  return (
    <Box sx={{ mt: 0.75 }}>
      {!failed && (
        <LinearProgress
          variant={percent != null ? "determinate" : "indeterminate"}
          value={percent ?? undefined}
          sx={{ height: 6, borderRadius: 3 }}
        />
      )}
      <Typography
        variant={"caption"}
        color={failed ? "error" : "text.secondary"}
      >
        {text}
      </Typography>
    </Box>
  );
}
